import { createBackTest } from 'state/backTest/backTest.actions';
import { getBackTestByTabId } from 'state/backTest/backTest.selector';
import { missedDealFeedbackInitThunk } from 'state/missed-deal-feeedback/thunk';
import { getQuoteExternalIdByWorkspaceTab } from 'state/selectors/common/temp';
import type { Thunk } from 'state/state.common';
import type { QuoteWorkspaceType } from 'state/workspaces/model';

import { changeTabInSidePanel } from './sidePanelUi.action';
import type { SidePanelTabId } from './sidePanelUi.model';

export function changeTabInSidePanelThunk(
  workspaceType: QuoteWorkspaceType,
  tabId: string,
  activeTab: SidePanelTabId,
): Thunk<void> {
  return (dispatch, getState) => {
    const state = getState();
    if (activeTab === 'backTest') {
      const backTest = getBackTestByTabId(state, tabId);
      const quoteId = getQuoteExternalIdByWorkspaceTab(state, workspaceType, tabId);
      if (!!quoteId && backTest?.quoteIds?.initialQuoteId !== quoteId) {
        dispatch(createBackTest(tabId, quoteId));
      }
    }
    dispatch(changeTabInSidePanel(tabId, activeTab));
    if (activeTab === 'missedDealFeedback') {
      dispatch(missedDealFeedbackInitThunk(tabId));
    }
  };
}
